<template>
	<div>
		<el-form ref="splitform" :model="form" label-width="80px" size="mini">
			<el-form-item label="线上单号" class="item">
				<el-input v-model="form.tptid" readonly></el-input>
			</el-form-item>
			<el-form-item label="原单金额" class="item">
				<el-input v-model="form.amount" readonly></el-input>
			</el-form-item>
			<el-form-item label="拆分金额" class="item">
				<el-input v-model="form.splitamount" readonly></el-input>
			</el-form-item>
		</el-form>
		<el-divider content-position="center">拆分列表</el-divider>
		<vxe-table ref="splitorderTable" style="margin-top: 8px;" :data="row.orders" size="mini" max-height="400px"
			:checkbox-config="{trigger: 'row'}" border @checkbox-change="checkboxChange" @checkbox-all="checkboxChange">
			<vxe-column type="checkbox" width="40"></vxe-column>
			<vxe-column field="item_name" title="商品名称"></vxe-column>
			<vxe-column field="payment" title="应收款"></vxe-column>
			<vxe-column field="sku_code" title="规格"></vxe-column>
			<vxe-column field="size" title="数量"></vxe-column>
			<vxe-column field="price" title="单价"></vxe-column>
			<vxe-column field="unit" title="单位"></vxe-column>
			<vxe-column title="操作" width="120" align="center">
				<template #default="{ row }">
					<el-link style="font-size: 12px;" target="_blank" type="primary" :href="row.item_platform_url"
						:disabled="!row.item_platform_url?true:false">详情页</el-link>
				</template>
			</vxe-column>
		</vxe-table>


	</div>
</template>
<style>

</style>
<style scoped>
	.item {
		margin-bottom: 4px;
	}
</style>
<script>
	export default {
		name: 'invoiceoutputSplitIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				amount: 0,
				form: {
					id: 0,
					tptid: '',
					order: [],
					amount: 0,
					splitamount: 0,
					splitorder: []
				}
			}
		},
		watch: {

		},
		mounted() {
			this.amount = parseFloat(this.row.amount)
			this.form.id = this.row.id
			this.form.order = this.row.order
			this.form.tptid = this.row.tptid
			this.form.amount = this.row.amount
		},
		computed: {

		},

		methods: {
			submit() {

				if (this.form.amount == 0) {
					this.$message.error('原金额不能为0')
					return false
				} else if (this.form.splitamount == 0) {
					this.$message.error('拆分金额不能为0')
				} else {
					return this.form
				}

			},
			checkboxChange() {
				let data = this.$refs.splitorderTable.getTableData()
				let order = []
				let splitorder = []
				let splitamount = 0
				data.fullData.forEach((item) => {
					if (this.$refs.splitorderTable.isCheckedByCheckboxRow(item)) {
						splitamount += parseFloat(item.payment)
						splitorder.push(item)
					} else {
						order.push(item)
					}

				})
				this.form.order = order
				this.form.splitorder = splitorder
				this.form.amount = (this.amount - splitamount).toFixed(4)
				this.form.splitamount = splitamount.toFixed(4)
			}
		},
		components: {

		}
	}
</script>
